import { useState, useEffect, useCallback } from 'react'

const useKeyboardNavigation = (itemCount, columns, onSelect, enabled = true) => {
  const [focusedIndex, setFocusedIndex] = useState(0)

  useEffect(() => {
    if (itemCount > 0 && focusedIndex >= itemCount) {
      setFocusedIndex(Math.max(0, itemCount - 1))
    }
  }, [itemCount, focusedIndex])

  const handleKeyDown = useCallback((e) => {
    if (!enabled || itemCount === 0) return

    if (columns === 0 && ['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
      return
    }

    const currentRow = Math.floor(focusedIndex / columns)
    const currentCol = focusedIndex % columns
    const totalRows = Math.ceil(itemCount / columns)

    let newIndex = focusedIndex

    switch (e.key) {
      case 'Tab':
        return

      case 'ArrowRight':
        e.preventDefault()
        if (columns > 1 && currentCol < columns - 1 && focusedIndex < itemCount - 1) {
          newIndex = focusedIndex + 1
        }
        break

      case 'ArrowLeft':
        e.preventDefault()
        if (columns > 1 && currentCol > 0) {
          newIndex = focusedIndex - 1
        }
        break

      case 'ArrowDown':
        e.preventDefault()
        if (columns === 1) {
          if (focusedIndex < itemCount - 1) {
            newIndex = focusedIndex + 1
          }
        } else {
          if (currentRow < totalRows - 1) {
            newIndex = Math.min(focusedIndex + columns, itemCount - 1)
          }
        }
        break

      case 'ArrowUp':
        e.preventDefault()
        if (columns === 1) {
          if (focusedIndex > 0) {
            newIndex = focusedIndex - 1
          }
        } else {
          if (currentRow > 0) {
            newIndex = focusedIndex - columns
          }
        }
        break

      case ' ':
      case 'Spacebar':
      case 'Enter':
        e.preventDefault()
        if (onSelect) {
          onSelect(focusedIndex)
        }
        return

      default:
        return
    }

    if (newIndex !== focusedIndex && newIndex >= 0 && newIndex < itemCount) {
      setFocusedIndex(newIndex)
    }
  }, [focusedIndex, itemCount, columns, enabled, onSelect])

  return {
    focusedIndex,
    setFocusedIndex,
    handleKeyDown
  }
}

export default useKeyboardNavigation
